import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
// import { NgxSignaturePadComponent, NgxSignatureOptions } from '@eve-sama/ngx-signature-pad';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConsentFinancialSettings } from 'src/app/models/consentfinancial/consentfinancial';
import { PDFProgressData } from 'ng2-pdf-viewer';
//import { SignaturePad } from 'angular2-signaturepad';
import { CareTEamService } from 'src/app/services/care-team.service';
import { TranslateService } from '@ngx-translate/core';
import SignaturePad from 'signature_pad';
declare var $: any;

@Component({
  selector: 'app-financial-form',
  templateUrl: './financial-form.component.html',
  styleUrls: ['./financial-form.component.css']
})
export class FinancialFormComponent implements OnDestroy{
  pageNum:any;
  totalPages:any;
  @ViewChild('agree') checkboxAgree: ElementRef;
  
  cfsm: ConsentFinancialSettings;
  patientPersonalInfo: PatientPersonalInfo;
  pdfPath1: any = "";
  zoopLevel: number = 1;
  isDevice = false;
  isRTL: boolean = false;
  constructor(private translateService: TranslateService, private service: CareTEamService,private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private activeRoute : ActivatedRoute,  private router: Router, private sanitizer: DomSanitizer) {
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      this.router.navigateByUrl("/");
      return;
    }

    
    // Navigator.user
    let isAndroid = /(android)/i.test(navigator.userAgent); 
    let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if(isAndroid || isIOS){
      this.zoopLevel = 0.5;
    }
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.isRTL = false;
        this.phrUtils.setTitle("Formulario financiero");
      } else if (language === 'hi') {
        this.isRTL = false;
        this.phrUtils.setTitle('वित्तीय स्वरूप');
      }
      else if (language === 'ur') {
        this.isRTL = true;
        this.phrUtils.setTitle('مالیاتی فارم');
      }
      else {
        this.isRTL = false;
        this.phrUtils.setTitle("Financial Form");
      }
    });

    this.patientPersonalInfo = this.phrUtils.decrypt(localStorage.getItem('PersonalInfo')) as PatientPersonalInfo;
    this.patientName = this.patientPersonalInfo.LASTNAME + ', ' + this.patientPersonalInfo.FIRSTNAME;
    this.spinner.show();
    let havFinForm = localStorage.getItem("financialCheck");
    if(havFinForm){
      this.cfsm = JSON.parse(this.phrUtils.decrypt(havFinForm)) as ConsentFinancialSettings;
      if(this.cfsm.data.financial_Form !="True" || this.cfsm.data.iS_PATIENT_FINANCIAL_AGREE.toLowerCase()=='true'){
        this.router.navigateByUrl("patient/updateinfo");
      }
      else if(this.cfsm.data.financial_Form_Path){
        this.pdfPath1 = this.getPdfUrl(this.cfsm.data.financial_Form_Path);
        // this.pdfPath1 = "https://researchtorevenue.files.wordpress.com/2015/04/1r41ai10801601_fong.pdf";
      } 
    }
    else{
      this.router.navigateByUrl("patient/updateinfo");
    }
    let pagesorder=localStorage.getItem('pagesorder');
    this.pageNum =JSON.parse(pagesorder?pagesorder:'').financial_form;
    this.totalPages=localStorage.getItem('totalPages');
  }

  @ViewChild('signatureCanvas') signatureCanvas: ElementRef;
  isEmpty: boolean = true;
  signaturePad: SignaturePad;
  
  ngAfterViewInit() {
    const canvas = this.signatureCanvas.nativeElement;
    this.signaturePad = new SignaturePad(canvas, {
      minWidth: 5,
      //canvasWidth: 500,
      //canvasHeight: 300
    });
  }

  clearSignature(){
    this.signaturePad.clear();
  }

  base64Signature: any;
  drawComplete() {
    this.base64Signature = this.signaturePad.toDataURL();
    //console.log('base64 signature = ');
    //console.log(this.base64Signature);
  }

  drawStart() {
    this.isEmpty = false;
  }
  
  getPdfUrl(token:any ) : any{
    return this.service.getDocumentFileUrl(this.patientPersonalInfo.PATIENT_ACCOUNT, token);
  }

  onProgress(progressData: PDFProgressData) {
    if(progressData.loaded === progressData.total){
      this.spinner.hide();
    }
  }

  loaded(event: any) {
    this.spinner.hide();
  }
  
  onError(error: any) {
    this.spinner.hide();
    this.phrUtils.showError(error.message);
  }
  
  ngOnDestroy(): void {
    //need this setting for covid form and symptoms checker that's way comment the line (muhammad Ahtasham)
    //localStorage.removeItem("financialCheck");
  }
  
  onClear(){
    this.checkboxAgree.nativeElement.checked = false;
    this.patientName = "";
  }
  
  agreeToTerms(e: any){
    if(e.target.checked){
      this.patientName = this.patientPersonalInfo.LASTNAME + ', ' + this.patientPersonalInfo.FIRSTNAME;
    }
    else{
      this.patientName = "";
    }
  }


  dataURLToBlob(dataURL:any) {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }
  readFileAndSendFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const imgBlob = new Blob([reader.result?reader.result:''], {
        type: file.type
      });
      this.spinner.show();
      this.service.SaveSignature(imgBlob,'api/TalkCheckin/AddSignatureToConsentForm',this.patientPersonalInfo.PATIENT_ACCOUNT.toString(), this.patientPersonalInfo.PRACTICE_CODE.toString(),this.patientPersonalInfo.LASTNAME.toString(),this.patientPersonalInfo.FIRSTNAME.toString(),'Financial Form')
    .subscribe((res : any) => {
      this.spinner.hide();
      if(res && res.statusCode == 200 && res.message == 'success'){
        $('#SignatureModal').modal('hide');
        this.router.navigateByUrl('patient/updateinfo');
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
      }
    },(error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
    };
    reader.readAsArrayBuffer(file);
  }

  patientName: string = "";
  applySIgnature(){
    if (this.signaturePad.isEmpty()) {
      let text = "Please draw your signature.";
      this.translateService.get('Alerts.consentForm_draw_signature').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
      //this.phrUtils.showInfo("Please draw your signature.");
      return;
    }
    const dataUrl = this.signaturePad.toDataURL();
    const blob = this.dataURLToBlob(dataUrl);
    this.readFileAndSendFile(blob);
  }

  onIAgreeClick(){
  //  $('#SignatureModal').modal('show');
    $('#FinancialModal').modal('show');
  }
  
  
  dissAgreedClicked(){
    let query = sessionStorage.getItem('AccessLink');
    // localStorage.setItem("backToConsent", "1");
    if(query == null){
      query = '';
    }
    this.router.navigateByUrl("patient/verifypatient?pa="+query);
  }

  addFinancial() {
    this.spinner.show();
    const imgBlob = 'null';
    this.service.SaveSignature(imgBlob, 'api/TalkCheckin/AddSignatureToConsentForm', this.patientPersonalInfo.PATIENT_ACCOUNT.toString(), this.patientPersonalInfo.PRACTICE_CODE.toString(), this.patientPersonalInfo.LASTNAME.toString(), this.patientPersonalInfo.FIRSTNAME.toString(), 'Financial Form')
      .subscribe((res: any) => {
        // {statusCode: 200, message: "success", data: null}
        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == 'success') {
          $('#FinancialModal').modal('hide');
          this.router.navigateByUrl('patient/updateinfo');
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          console.log("AddSignatureToConsentForm failed in financial form");
          $('#FinancialModal').modal('hide');
          this.router.navigateByUrl('patient/updateinfo');
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        console.log("AddSignatureToConsentForm failed in financial form");
        $('#FinancialModal').modal('hide');
        this.router.navigateByUrl('patient/updateinfo');
        //this.phrUtils.showError("Service is not available, please try later.");
      });
  }
  
}
